import axios from 'axios'
import store from '@/store'
import { getStorage } from '@/utils'
const baseURL = process.env.VUE_APP_BASE_URL
console.log(baseURL, 'baseURL')
const isXZH = process.env.VUE_APP_PROJECT_NAME === '新综合'

// 创建一个axios实例
const instance = axios.create({
  headers: {
    'content-type': 'application/json;charset=UTF-8'
  },
  baseURL, // api的base_url
  timeout: 65 * 1000 // request timeout
  // withCredentials: true
})

// 不需要携带token的api
const whiteListNoTokenApi = function(url) {
  const list = ['/auth?tenantId=', '/auth']
  let need = true
  for (const part of list) {
    if (url.indexOf(part) !== -1) {
      need = false
      return need
    }
  }
  return need
}

instance.interceptors.request.use(
  (config) => {
    settingToken(config) // 给config设置不同api下的不同token
    if (!whiteListNoTokenApi(config.url)) { // 不需要携带token的接口
      delete config.headers.Authorization
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

// 根据api不同设置不同的token
const settingToken = function(config) {
  const token = getStorage('token', 0)
  if (token) {
    config.headers.Authorization = isXZH ? `bearer ${token}` : `Bearer ${token}`
  }
}

function refreshToken() {
  // instance是当前request.js中已创建的axios实例

  const account = getStorage('user', 0)
  if (isXZH) {
    return store.dispatch('user/XZSLogin', account).then(res => res.data)
  } else {
    const obj = {account: account.account, tenantId: account.tenantId }

    return store.dispatch('user/LoginForm', obj).then(res => res)
  }
}

// 是否正在刷新的标记
let isRefreshing = false
// 重试队列，每一项将是一个待执行的函数形式
let requests = []

instance.interceptors.response.use((response) => {
  return response.data
}, (error) => {
  const { status } = error.response
  if (status === 401 || status === 403) {
    const { config } = error.response
    if (!isRefreshing) {
      isRefreshing = true
      return refreshToken().then((res) => {
        const { token } = res
        config.headers.Authorization = token
        config.baseURL = process.env.VUE_APP_BASE_URL
        // 已经刷新了token，将所有队列中的请求进行重试
        requests.forEach((cb) => cb(token))
        requests = []
        return instance(config)
      }).catch((res) => {
        // window.location.href = '/'
      }).finally(() => {
        isRefreshing = false
      })
    }
    // 正在刷新token，将返回一个未执行resolve的promise
    return new Promise((resolve) => {
      // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
      requests.push((token) => {
        config.baseURL = process.env.VUE_APP_BASE_URL
        config.headers.Authorization = token
        resolve(instance(config))
      })
    })
  }
  return Promise.reject(error)
})

export default instance
